import { Alert, AlertDescription, AlertIcon, AlertTitle, Container, Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

import NavLink from '@/components/UI/Links/NavLink';

import RoutePath from '@/constants/route-path';

export const RemindPasswordSent = () => {
    return (
        <Container maxW="2xl">
            <Alert
                status="success"
                variant="subtle"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                padding={6}
                bgColor="white"
            >
                <AlertIcon boxSize="40px" mr={0} color="brand.main" />

                <AlertTitle mt={4} mb={1} fontSize="xl" color="black" fontWeight="semibold">
                    <FormattedMessage id="page.remind-password.success"></FormattedMessage>
                </AlertTitle>
                <AlertDescription maxWidth="sm">
                    <Text mx="auto" fontSize="sm" mb={6}>
                        <FormattedMessage id="page.remind-password.success.description"></FormattedMessage>
                    </Text>
                    <NavLink skipRouter={true} href={RoutePath.Home} variant="underlineBrand">
                        <FormattedMessage id="go-to-homepage" />
                    </NavLink>
                </AlertDescription>
            </Alert>
        </Container>
    );
};
